/*
 |--------------------------------------------------------------------------
 | Laravel Spark Bootstrap
 |--------------------------------------------------------------------------
 |
 | First, we will load all of the "core" dependencies for Spark which are
 | libraries such as Vue and jQuery. This also loads the Spark helpers
 | for things such as HTTP calls, forms, and form validation errors.
 |
 | Next, we'll create the root Vue application for Spark. This will start
 | the entire application and attach it to the DOM. Of course, you may
 | customize this script as you desire and load your own components.
 |
 */

require('spark-bootstrap');

require('./components/bootstrap');

window.Swal = require('sweetalert2');

window.Swal = Swal.mixin({
    buttonsStyling: false,
    customClass: {
        confirmButton: 'btn btn-primary btn-lg btn-pill',
        cancelButton: 'btn btn-default btn-lg btn-pill'
    },
})

window.SwalPrompt = Swal.mixin({
    position: 'top',
    allowOutsideClick: false,
    backdrop: true,
    customClass: {
        popup: 'swal2-prompt',
        confirmButton: 'btn btn-primary btn-lg btn-pill',
        cancelButton: 'btn btn-default btn-lg btn-pill'
    }
})

if (location.hostname.indexOf('app.snazzydocs.com') === -1) {
    Vue.config.debug = true;
} else {
    Vue.config.devtools = false;
    Vue.config.debug = false;
    Vue.config.silent = true;
    Vue.config.productionTip = false;
}

let environment = 'local'
if (location.hostname === 'app.snazzydocs.com') environment = 'production'
if (location.hostname === 'staging.snazzydocs.com') environment = 'staging'

import HoneybadgerVue from '@honeybadger-io/vue'

if (environment === 'production') {
    const config = {
        apiKey: 'f05ce7b8',
        environment: environment
    }

    Vue.use(HoneybadgerVue, config)
}



import '../sass/blank.scss'; // Workaround to fix async components with css imports inside causing failure to locate async compnonent

import TeamChannel from "./components/mixins/team-channel.js";

import OnlineTeamMembers from "./components/dashboard/OnlineTeamMembers.vue";


const Dashboard = () => import( /* webpackPrefetch: true */ './components/dashboard/Dashboard.vue' /* webpackChunkName: "js/dashboard" */)

const GlobalAlert = () => import( /* webpackPrefetch: true */ './components/components/GlobalAlert.vue' /* webpackChunkName: "js/components/global-alert" */)

const Editor = () => import( /* webpackPrefetch: true */ './components/editor/index.vue' /* webpackChunkName: "js/editor/index" */)

const ImportModal = () => import( /* webpackPrefetch: true */ './components/modals/ImportModal.vue' /* webpackChunkName: "js/import-modal" */)

const ImportHtml = () => import( /* webpackPrefetch: true */ './components/dashboard/ImportHTML.vue' /* webpackChunkName: "js/import-html" */)

const ImportCsv = () => import( /* webpackPrefetch: true */ './components/dashboard/ImportCSV.vue' /* webpackChunkName: "js/import-csv" */)


Spark.forms.register = {
    unique_id: ''
};

var app = new Vue({
    mixins: [
        require('spark'),
        TeamChannel,
    ],

    components: {
        GlobalAlert,
        OnlineTeamMembers,
        Dashboard,
        Editor,
        ImportModal,
        ImportHtml,
        ImportCsv
    },

    data: {
        currentHash: window.location.hash,
        currentPage: null,
        userSessionActive: true,

        hustlePlanFeatures: [
            '1 Doc',
            '10 Pages',
            'Free Hosting',
            'Custom Domain',
            'Themes',
            'Private Docs'
        ],

        essentialsPlanFeatures: [
            '5 Docs',
            'Unlimited Pages',
            'Self Hosting',
            'Premium Themes',
            'Custom Styles',
            'Landing Page',
            'History Timeline',
            'Page History'
        ],

        professionalPlanFeatures: [
            '20 Docs',
            'Teams',
            'Real-time collaboration',
            'G-Suite Sign-in',
            'Integrations'
        ],

        enterprisePlanFeatures: [
            '200 Docs',
            // '250MB Storage',
        ],

        store: {},
    },

    mounted() {
        this.currentHash = this.currentHash.substring(this.currentHash.indexOf("#") + 2);

        if (this.userIsInTeam && this.$root.userSessionActive && !window.hasOwnProperty('Pusher') && !window.hasOwnProperty('Echo')) {
            this.initTeamChannel()
        }

        let self = this
        this.$nextTick(function () {

            this.setCurrentPage();

            let options = {
                passive: true
            }

            window.addEventListener("hashchange", function (e) {

                self.currentHash = e.newURL.substring(e.newURL.indexOf("#") + 2);
                self.setCurrentPage();

            }, options);

        })

    },

    computed: {
        userIsInTeam() {
            return this.spark.state.teams.length
        }
    },

    methods: {

        firstName(value) {
            return value.split(" ")[0]
        },

        setCurrentPage() {
            let urlSegments = window.location.pathname.split('/');

            if (this.currentHash === 'profile' || this.currentHash === 'security' || this.currentHash === 'subscription') {
                this.currentPage = 'account'
            }

            if (urlSegments[1] === 'settings' && urlSegments.length === 2 && this.currentHash !== 'teams' || urlSegments[2] === 'addons' || urlSegments[2] === 'usage' || urlSegments[2] === 'archives') {
                this.currentPage = 'account'
            }

            if (urlSegments[1] === 'settings' && urlSegments[2] === 'teams' && urlSegments.length >= 3 || this.currentHash === 'teams') {
                this.currentPage = 'teams'
            }
        },

        refreshApiToken() {
            console.log('[ refreshApiToken ]');

            this.lastRefreshedApiTokenAt = moment();

            axios.put('/spark/token')
                .then(response => {
                    // console.log('done: ', response);
                }).catch(error => {
                    Vue.set(this, 'userSessionActive', false)
                    Bus.$emit('user-session-expired')

                    showSessionExpiredPopup()
                });
        },

        generateId() {
            var sValidCharacters = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
            var sCharCode = "";

            for (var i = 0; i < 13; i++) {
                sCharCode =
                    sCharCode +
                    sValidCharacters.charAt(
                        parseInt(Math.random() * sValidCharacters.length)
                    );

                if (i === 2 || i === 6 || i === 9) {
                    sCharCode = sCharCode + "-";
                }
            }

            return sCharCode;
        },

    }

});


// Effects tooltip OUTSIDE of editor!
$('[data-toggle="tooltip"]').tooltip({
    delay: {
        "show": 100,
        "hide": 100
    },
    container: 'body',
    trigger: 'hover'
});

window.showToast = function (title, type, timer = 3000, position = 'bottom-end', showCloseButton = false, actionButtonText = '', callback = null, pullTop = false) {

    const Toast = Swal.mixin({
        toast: true,
        buttonsStyling: false,
        position: type === 'error' ? 'top-end' : position,

        showConfirmButton: callback ? true : false,
        cancelButtonText: '',
        confirmButtonText: actionButtonText ? actionButtonText : '',
        timerProgressBar: true,
        showCancelButton: type === 'error' ? true : showCloseButton,

        timer: type === 'error' ? 0 : timer,
        customClass: {
            container: pullTop ? 'swal-container-pull-top' : '',
            confirmButton: 'btn btn-primary btn-sm btn-pill',
            cancelButton: 'btn btn-action zmdi zmdi-close zmdi-hc-2x',
        },
        onOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });

    Toast.fire({
        icon: type,
        title: title,
        showClass: {
            popup: type === 'error' ? 'animated fadeInRight' : 'animated fadeInUp'
        },
        hideClass: {
            popup: type === 'error' ? 'animated fadeOutRight faster' : 'animated fadeOutDown'
        }
    }).then(result => {
        if (callback && result && result.value == true) {
            callback(result && result.value == true);
        }
    });
}

window.showPlanLimitNotification = function (error, plan_name = null) {
    let title = 'Oh man...';
    let message = '';
    let image = '';

    switch (error) {
        case 'premium_themes':
            message = 'Premium themes can\'t be used with the ' + plan_name + ' plan.';
            image = 'icon-quotareached.svg';
            break;
        case 'premium_feature':
            message = 'This is a premium feature that can\'t be used with the ' + plan_name + ' plan.';
            image = 'icon-quotareached.svg';
            break;
        case 'docs_quota':
            message = 'You have reached the maximum number of docs for the ' + plan_name + ' plan.';
            image = 'icon-quotareached.svg';
            break;
        case 'storage_quota':
            message = 'You have reached the maximum disk storage for your current plan.';
            image = 'icon-quotareached.svg';
            break;
        case 'doc_pages_quota':
            message = 'You have reached the maximum number of pages in this doc for the ' + plan_name + ' plan.';
            image = 'icon-quotareached.svg';
            break;
        case 'integrations':
            message = 'You can\'t use integrations with the ' + plan_name + ' plan.';
            image = 'icon-quotareached.svg';
            break;
        default:
            message = 'You can\'t do that with the ' + plan_name + ' plan.';
            image = 'icon-quotareached.svg';
    }

    Swal.fire({
        showCancelButton: true,

        title: title,
        text: message,
        confirmButtonText: 'Upgrade plan',
        cancelButtonText: 'I\'ll look later',
        imageUrl: '/img/gfx/' + image,
        imageHeight: 75,
        imageAlt: 'Plan Quota Reached Image',
    }).then((result) => {
        if (result.value) {
            //console.log('confirm hit', result);
            window.location = '/settings#/subscription';
        }
    })
}

window.showSessionExpiredPopup = function () {
    Swal.fire({
        showCancelButton: false,
        allowOutsideClick: false,
        closeOnClickOutside: false,
        title: 'Session expired',
        text: 'Your login session has expired. Please resume to continue.',
        confirmButtonText: 'Resume session',
        imageUrl: '/img/gfx/icon-waving-hand.svg',
        imageHeight: 75,
        imageAlt: 'Session expired image',
    }).then((result) => {
        if (result.value) {
            location.reload();
        }
    })
}

window.showQuotaNotification = function (error, plan_name) {
    let title = 'Oh man...';
    let text = 'You have reached the maximum number of docs for the ' + plan_name + ' plan.';

    Swal.fire({
        showCancelButton: true,
        title: title,
        text: text,
        confirmButtonText: 'View Plans',
        cancelButtonText: 'I\'ll look later',
        imageUrl: '/img/gfx/icon-quotareached.svg',
        imageHeight: 75,
        imageAlt: 'Plan Quota Reached Image',
    }).then((result) => {
        if (result.value) {
            window.location = 'settings#/subscription';
        }
    })
}

// Is this needed? there is a method in onboarding.js as well?
window.onboardingEventCompleted = function (event_name, user_id) {

    axios.post('/onboarding/completed', {
        event_name: event_name,
        user_id: user_id
    }).then(function (response) {

    }).catch(function (error) {
        //console.log(error);
    });
}

window.swal2_alert = function (title = '', text = '', image = null, html = null) {
    if (!image) {
        image = 'icon-error.svg';
    }

    if (html) {
        Swal.fire({
            title: title,
            html: html,
            confirmButtonText: 'Ok',
            imageUrl: '/img/gfx/' + image,
            imageHeight: 75,
            imageAlt: '',
        }).then((result) => {
            if (result.value) {
                //console.log('confirm hit', result);
                //window.location = 'settings#/subscription';
            }
        })
    } else {
        Swal.fire({
            title: title,
            text: text,
            confirmButtonText: 'Ok',
            imageUrl: '/img/gfx/' + image,
            imageHeight: 75,
            imageAlt: '',
        }).then((result) => {
            if (result.value) {
                //console.log('confirm hit', result);
                //window.location = 'settings#/subscription';
            }
        })
    }
}

window.showUnavailableInDemo = function () {

    Swal.fire({
        showCancelButton: true,
        title: 'psst...',
        text: 'This is unavailable in demo mode.',
        confirmButtonText: 'Create an account',
        cancelButtonText: 'Close',
        imageUrl: '/img/gfx/icon-error.svg',
        imageHeight: 75,
        imageAlt: '',
    }).then((result) => {
        if (result.value) {
            //console.log('confirm hit', result);
            window.location = '/demo/register';
        }
    })

}

window.swal2_confirm = function (form = null, image = null) {
    event.preventDefault();

    if (!image) {
        image = 'icon-question.svg'
    }

    Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to undo this.",
        showCancelButton: true,
        confirmButtonText: 'Yes',
        imageUrl: '/img/gfx/' + image,
        imageHeight: 75,
        imageAlt: 'Confirm Image',
    }).then((result) => {
        if (result.value) {
            form.submit();
        }
    })
}

var dropdownSelectors = $('.dropdown, .dropup');

// Custom function to read dropdown data
// =========================
var dropdownEffectData = function (target) {
    var effectInDefault = null,
        effectOutDefault = null;
    var dropdown = $(target),
        dropdownMenu = $('.dropdown-menu', target);
    var parentUl = dropdown.parents('ul.nav');

    // If parent is ul.nav allow global effect settings
    if (parentUl.length > 0) {
        effectInDefault = parentUl.data('dropdown-in') || null;
        effectOutDefault = parentUl.data('dropdown-out') || null;
    }

    return {
        target: target,
        dropdown: dropdown,
        dropdownMenu: dropdownMenu,
        effectIn: dropdownMenu.data('dropdown-in') || effectInDefault,
        effectOut: dropdownMenu.data('dropdown-out') || effectOutDefault,
    };
}

// Custom function to start effect (in or out)
// =========================
var dropdownEffectStart = function (data, effectToStart) {
    if (effectToStart) {
        data.dropdown.addClass('dropdown-animating');
        data.dropdownMenu.addClass('animated');
        data.dropdownMenu.addClass(effectToStart);
    }
}

// Custom function to read when animation is over
// =========================
var dropdownEffectEnd = function (data, callbackFunc) {
    var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
    data.dropdown.one(animationEnd, function () {
        data.dropdown.removeClass('dropdown-animating');
        data.dropdownMenu.removeClass('animated');
        data.dropdownMenu.removeClass(data.effectIn);
        data.dropdownMenu.removeClass(data.effectOut);

        // Custom callback option, used to remove open class in out effect
        if (typeof callbackFunc == 'function') {
            callbackFunc();
        }
    });
}

// Bootstrap API hooks
// =========================
dropdownSelectors.on({
    "show.bs.dropdown": function () {
        // On show, start in effect
        var dropdown = dropdownEffectData(this);
        dropdownEffectStart(dropdown, dropdown.effectIn);
    },
    "shown.bs.dropdown": function () {
        // On shown, remove in effect once complete
        var dropdown = dropdownEffectData(this);
        if (dropdown.effectIn && dropdown.effectOut) {
            dropdownEffectEnd(dropdown, function () { });
        }
    },
    "hide.bs.dropdown": function (e) {
        // On hide, start out effect
        var dropdown = dropdownEffectData(this);
        if (dropdown.effectOut) {
            e.preventDefault();
            dropdownEffectStart(dropdown, dropdown.effectOut);
            dropdownEffectEnd(dropdown, function () {
                dropdown.dropdown.removeClass('open');
            });
        }
    },
});
